import { IServerSideGetRowsRequest } from 'ag-grid-community';
import { ISort } from 'apiConnector/blotters';
import type { FilterTranslator } from 'components/shared/Blotter/Grid/Hooks/requestTranslator';
import {
  dateTranslator,
  numberTranslator,
  setTranslator,
  textTranslator,
} from 'components/shared/Blotter/Grid/Hooks/requestTranslator';
import { sortBy } from 'lodash-es';
import { useCallback, useMemo } from 'react';

export function useDefaultSortTranslator() {
  return useCallback((gridRequest: IServerSideGetRowsRequest): ISort[] => {
    return gridRequest.sortModel.map(sortCol => ({ column: sortCol.colId, direction: sortCol.sort }) as ISort);
  }, []);
}

export function useDefaultFilterTranslators(
  additionalTranslators?: readonly FilterTranslator[],
): readonly FilterTranslator[] {
  return useMemo(() => {
    const translators = [
      dateTranslator(),
      setTranslator(),
      textTranslator(),
      numberTranslator(),
      ...(additionalTranslators ?? []),
    ] as FilterTranslator[];
    return sortBy(translators, t => t.col);
  }, [additionalTranslators]);
}
